import { AtomicBlockUtils } from 'wix-rich-content-editor-common';
import { getDefaultComponentData } from './types';
export const attachImage = (deviation, editorState)=>{
    var _newBlock;
    const data = getDefaultComponentData();
    data.data = deviation;
    // Create the entity
    const contentState = editorState.getCurrentContent();
    const contentStateWithEntity = contentState.createEntity('wix-draft-plugin-image', 'IMMUTABLE', data);
    const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
    // Insert a new block
    const newEditorState = AtomicBlockUtils.insertAtomicBlock(editorState, entityKey, ' ');
    const recentlyCreatedKey = newEditorState.getSelection().getAnchorKey();
    const newBlock = newEditorState.getCurrentContent().getBlockBefore(recentlyCreatedKey);
    // Component has block key update it by ref.
    data.config.key = (_newBlock = newBlock) === null || _newBlock === void 0 ? void 0 : _newBlock.getKey();
    return newEditorState;
};
